var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferralAdvocateShareIcons(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 116 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.844 7.323l-.249.968.249-.968C26.757 3.495 11.53 12.503 7.696 27.525a27.669 27.669 0 00-.26 12.648L1.813 51.128s0 0 0 0c-.783 1.524.277 3.329 1.976 3.416h0l12.354.632a27.987 27.987 0 0011.14 6.101c14.984 4.204 30.443-4.4 34.657-19.323 4.27-15.12-4.807-30.752-20.095-34.631z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.34 25.997l-.43.428-.429-.428c-3.054-3.038-8.006-3.038-11.06 0a7.75 7.75 0 000 11.002l10.467 10.412a1.452 1.452 0 002.046 0L46.4 36.999a7.75 7.75 0 000-11.002c-3.054-3.038-8.005-3.038-11.06 0z",
    fill: "#DDB9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4 37L35.935 47.41a1.451 1.451 0 01-2.046 0l-2.236-2.223c.474.172 1.024.069 1.403-.31l9.691-9.638a7.176 7.176 0 000-10.186 7.19 7.19 0 00-1.848-1.335 7.816 7.816 0 015.503 2.28 7.75 7.75 0 010 11z",
    fill: "#E5C1DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.343 31.395l.036.998-.036-.998c11.131-.443 20.407 8.082 20.794 19.125a19.72 19.72 0 01-1.708 8.763l2.199 8.24s0 0 0 0c.367 1.375-.819 2.65-2.208 2.43h0l-8.506-1.345a20.207 20.207 0 01-8.63 2.56c-11.117.72-20.618-7.558-21.286-18.589-.676-11.178 8.065-20.735 19.345-21.184z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.02 45.442l.231.358.36-.232c2.553-1.648 5.954-.925 7.597 1.615 1.643 2.54.905 5.935-1.648 7.583l-8.75 5.647a1.017 1.017 0 01-1.407-.299l-5.63-8.704c-1.642-2.54-.904-5.935 1.65-7.583 2.553-1.648 5.954-.924 7.597 1.615z",
    fill: "#DDB9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.771 51.403l5.626 8.7c.305.47.933.604 1.405.299l1.868-1.206a.932.932 0 01-.917-.418l-5.21-8.053c-1.519-2.35-.836-5.492 1.526-7.017.465-.3.96-.515 1.469-.65a5.499 5.499 0 00-4.12.768c-2.551 1.647-3.288 5.039-1.647 7.577z",
    fill: "#E5C1DA"
  })));
}
export default SvgReferralAdvocateShareIcons;